<script>
import AutomatorDocsManPage from "./AutomatorDocsManPage";

export default {
  name: "AutomatorDocsCommandList",
  components: {
    AutomatorDocsManPage
  },
  data() {
    return {
      selectedCommand: -1,
    };
  },
  computed: {
    categoryNames: () => GameDatabase.reality.automator.categoryNames,
    commands: () => GameDatabase.reality.automator.commands,
  },
  methods: {
    commandsInCategory(category) {
      return this.commands.filter(c => c.category === category && c.isUnlocked());
    }
  }
};
</script>

<template>
  <div>
    <div v-if="selectedCommand !== -1">
      <button
        class="c-automator-docs--button l-return-button fas fa-arrow-left"
        @click="selectedCommand = -1"
      />
      Вернуться к списку команд
    </div>
    <AutomatorDocsManPage
      v-if="selectedCommand !== -1"
      :command="commands[selectedCommand]"
    />
    <div
      v-else
      class="c-automator-docs-page"
    >
      Нажмите на подчёркнутую команду чтобы увидеть больше деталей о синтаксисе, использовании и функционале.
      <br>
      <br>
      <span>Список команд:</span>
      <br>
      <div
        v-for="(category, i) in categoryNames"
        :key="i"
      >
        {{ category }} ({{ ruQuantifyInt("команда,команды,команд", commandsInCategory(i).length) }})
        <div
          v-for="command in commandsInCategory(i)"
          :key="command.id"
          class="c-automator-docs-page__link l-command-group"
          @click="selectedCommand = command.id"
        >
          <span v-if="command.isUnlocked()">
            {{ command.keyword }}
          </span>
        </div>
      </div>
      <br>
      <span>
        Примечание: В записке СИНТАКСИС на каждой команде, <u>подчеркнутые</u> вводные данные <i>обязательные</i> , их
        вы должны заполнить, а вводные данные в [квадратных скобках] опциональны (если используются, они должны быть
        введены <i>без</i> скобок). Любые другие части должны быть напечатаны так, как они есть. Если не сказано иначе,
        все вводные данные нечувствительные к регистру. Некоторые команды могут иметь более одного допустимого формата,
        который будет появляться на разных строках.
      </span>
    </div>
  </div>
</template>

<style scoped>
.l-command-group {
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
}

.l-return-button {
  width: 4rem;
  height: 2.6rem;
  font-size: 1.8rem;
  margin-left: 2rem;
}
</style>
